import AppContainer from './container/AppContainer';
import './App.scss';

function App() {
	return <AppContainer />;
}

export default App;
